export const getMainDoorImage = (door) => {
    const mainVariant = door?.variants?.find((v) => (v.main === 1)) || door?.custom_variants?.find((v) => v.main === 1);
    const customVariant = door?.custom_variants?.find((v) => (v.main === 1)) || door?.custom_variants?.find((v) => v.main === 1);
    if (!mainVariant && !customVariant) return '';
    return mainVariant?.main_model || customVariant?.main_model;
};